var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"content"},[_c('b-col',{staticClass:"p-0",attrs:{"cols":"12","lg":"2"}},[_c('SearchGroup',{on:{"searchInput":_vm.searchInput}})],1),_c('b-col',{staticClass:"p-0",attrs:{"cols":"12","lg":"10"}},[_c('GroupsList',{attrs:{"search":_vm.search}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }